import React from 'react';

function AboutUs() {
    return (
        <div className="page-container">
            <h1>Dr Damon Whitten</h1>
            <p>
                Damon is a specialist provider of professional development to the tertiary sector, focusing on adult literacy and numeracy.
                He focuses on generating and connecting research to real-world contexts and using the results to develop effective teaching and learning approaches.
                Damon is at the forefront of adult education and works toward empowering and reengaging adult learners with their dreams, passions and potentials through numeracy and literacy education.
            </p>
            <div className="image-scroll-container">
                <img src="https://source.unsplash.com/random/600x400/?educators,team,meeting" alt="Our Team" className="image" />
                <img src="https://source.unsplash.com/random/600x400/?library,study,books" alt="Learning Environment" className="image" />
            </div>
            <p style={{ marginTop: "2rem" }}>Founded on the belief that learning is a lifelong journey, we strive to create an inclusive environment where every adult learner feels valued and inspired. We continuously adapt our curriculum to meet the evolving needs of our community and the modern world.</p>
        </div>
    );
}

export default AboutUs;
   